import { render } from "./App.vue?vue&type=template&id=7e3c41c6"
const script = {}

import "./styles/styles.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__